import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';

// ============================================================================
// Interfaces
// ============================================================================
interface DroppableSectionProps {
  children: React.ReactNode;
  id: string;
}

// ============================================================================
// Component
// ============================================================================
export const DroppableSection = ({ children, id }: DroppableSectionProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `section-${id}`,
    data: { type: 'section', id }
  });

  return (
    <Paper 
      ref={setNodeRef}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: isOver ? 'action.hover' : 'background.paper',
        transition: 'all 0.2s ease',
        border: theme => isOver ? `2px dashed ${theme.palette.primary.main}` : '2px solid transparent'
      }}
    >
      {children}
    </Paper>
  );
};
